import { useEditor } from "@craftjs/core";
import { Box, Typography } from "@mui/material";
import { createElement } from "react";

const Settings = () => {
    const { active, related } = useEditor((state, query) => {
        const currentlySelectedNodeId = query.getEvent("selected").first();

        return {
            active: currentlySelectedNodeId,
            related: currentlySelectedNodeId && state.nodes[currentlySelectedNodeId].related,
        };
    });

    return (
        <Box sx={{ height: "100%", pt: 1, pb: 1 }}>
            {active && related.settings && createElement(related.settings)}
            {active && !related.settings && (
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="caption" sx={{ textAlign: "center", mb: 2 }}>
                        No options available for this element.
                    </Typography>
                </Box>
            )}
            {!active && (
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="caption" sx={{ textAlign: "center", mb: 2 }}>
                        Click on a component to start editing.
                    </Typography>
                    <Typography variant="caption" sx={{ textAlign: "center" }}>
                        You can also navigate through the various components using the layers below.
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default Settings;
